import {
  Component,
  computed,
  HostBinding,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { BreakpointService } from '@app/services/breakpoint.service';
import { RemoveCountPipe } from '@app/pipes/remove-count.pipe';
import {
  MobiUiIconComponent,
  MobiUiPopoverComponents,
} from '@mobi/rwc-ui-components-ng-jslib';
import { HasResultPipe } from '@app/pipes/hasResult.pipe';

@Component({
  selector: 'mobi-tags-filter',
  standalone: true,
  imports: [
    ComponentSharedModule,
    RemoveCountPipe,
    MobiUiPopoverComponents,
    MobiUiIconComponent,
    HasResultPipe,
  ],
  templateUrl: './tags-filter.component.html',
  styleUrls: ['./tags-filter.component.scss'],
})
export class TagsFilterComponent implements OnInit {
  readonly filter = input.required<any>();
  readonly activeFilters = input.required<{ [key: string]: any }>();
  readonly centerFilters = input(false);
  readonly type = input<'checkboxes' | 'radios' | 'select'>('checkboxes');
  readonly scrollable = input(false);
  readonly isGrouped = input(false);

  open = signal(false);

  readonly filterChange = output<{ name: string; value: any; immediate?: boolean }>();
  readonly selectionChange = output<{ name: string; key: string | string[] }>();

  options = computed(() => {
    const options = this.filter()['#processedOptions'] || [];

    if (options.length === 1 && options[0].children && this.type() !== 'select') {
      return options[0].children;
    }

    return options;
  });
  breakpoint = inject(BreakpointService);
  @HostBinding('id') id = '';

  ngOnInit() {
    this.id = `tags-filter-${this.filter()['#name']}`;
  }

  onFilterChange(value: any, immediate?: boolean) {
    this.filterChange.emit({ name: this.filter()['#name'], value, immediate });
  }

  onSelectionChange(key: string | string[]) {
    this.selectionChange.emit({ name: this.filter()['#name'], key });
  }

  isChecked(optionKey: string | unknown): boolean {
    const filterName = this.filter()['#name'];
    const currentFilters = this.activeFilters()[filterName];
    const key = String(optionKey);

    if (this.type() !== 'radios') {
      return currentFilters?.includes(key) || false;
    } else {
      return currentFilters === key || this.filter()['#value'] === key;
    }
  }

  selectedText(children: any[]): string {
    const filterName = this.filter()['#name'];
    const currentFilters = this.activeFilters()[filterName] || [];
    const selectedOptions = children.filter((option: any) =>
      currentFilters.includes(option.key)
    );
    let selectedText = '';

    selectedOptions.forEach((key: any) => {
      selectedText += (selectedText ? ', ' : '') + key.value;
    });

    return selectedText;
  }

  filterCount(children: any[]): number {
    const filterName = this.filter()['#name'];
    const currentFilters = this.activeFilters()[filterName];

    return children.reduce((acc: number, child: any) => {
      if (currentFilters?.includes(child.key)) {
        return acc + 1;
      }
      return acc;
    }, 0);
  }

  isDefaultStyle(optionKey: string | unknown): boolean {
    return !this.isChecked(optionKey);
  }

  childrenSelected(children: any) {
    let hasSelected = false;
    children?.forEach((child: any) => {
      if (this.isChecked(child.key)) hasSelected = true;
    });

    return hasSelected;
  }

  all(children: any, deselect: boolean = false) {
    const changes = children
      .map((child: any) => child.key)
      .filter((key: string) => (deselect ? this.isChecked(key) : !this.isChecked(key)));
    this.onSelectionChange(changes);
  }
}
